import React from 'react'
import sumanth from '../../pages/about/ee/sumanth.png'
import Hero from './Hero'
import About from './About'
function Sumanth() {
  return (
    <section className="container-fluid p-0">
        <Hero title="SUMANTH RAM" subtitle="Sumanth is a highly creative and dedicated filmmaker with a Master's degree in Theatre Arts. His extraordinary skills as a screenwriter, particularly in creating captivating screenplays, are fuelled by his love of movies. In addition, he is a talented director who knows how to bring stage and film productions to life with accuracy and vision. Sumanth is a great asset to any movie production because of his innovative ideas and commitment to the craft of filmmaking." image={sumanth}/>
        </section>
  )
}

export default Sumanth; 